<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link> 
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getLogs(folderSelezionata,today,idEnteCorrente)">Accessi</a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1"> Log Errori</span>
				</h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(this.modulo)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(this.modulo)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation" v-for="folder in arrayLogsFolders" v-bind:key="folder.ID_FOLDER" @click="getLogs(folder.DESCRIZIONE,today,idEnteCorrente)">
						<a :href="'#logs-' + folder.ID_FOLDER" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" :class="{'active' : folder.ID_FOLDER == 1 , '' : folder.ID_FOLDER > 1}" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1">{{ folder.DESCRIZIONE }}</span>
								<span class="hidden-xs ms-1">Log {{ folder.DESCRIZIONE }}</span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								
							</div>
						</li>
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->	
		
	</div>
	<!-- /page header -->
	
	<!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div v-for="folder in arrayLogsFolders" v-bind:key="folder.ID_FOLDER" class="tab-pane fade" :class="{'active show' : folder.ID_FOLDER == 1 , '' : folder.ID_FOLDER > 1}" :id="'logs-'+folder.ID_FOLDER">

				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse show" id="collapse-all" style="">				
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" :id="'logs-'+folder.ID_FOLDER">
									<div class="row ">
										<div class="col-12 col-md-1 mbx-1">
											<select class="form-control form-control-sm" data-placeholder="Livello" :tabindex="3" >
												<option value="">TUTTI</option>
												<option value="DEBUG"> &nbsp; Debug</option>
												<option value="ERROR"> &nbsp; Errori</option>
											</select>
										</div> 
										<div class="col-12 col-md-2 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Messaggio" :tabindex="1"  />
										</div>
										<div class="col-12 col-md-2 mbx-1">
											<Datepicker  v-model="search.time" model-type="dd/MM/yyyy" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :hide-navigation="['time']"></Datepicker>
										</div>
										<div class="col-6 col-md-1 col-lg-1">
			                                <a v-show="search.time != filters.formatDate(today)" class="btn btn-flat-info btn-sm w-100" data-bs-toggle="collapse" v-on:click="getLogs(folderSelezionata, filters.formatDateReverse(search.time),idEnteCorrente)" role="button" aria-expanded="false">
												<span style="font-weight: 500;">Aggiorna</span>				
											</a>          
										</div> 
										<div class="d-none d-sm-block col-md-5 mbx-1">
										</div> 
										<div class="col-12 col-md-1 mbx-1">
											<select class="form-control form-control-sm" data-placeholder="Seleziona Anno">
												<option>Anno</option>
											</select>
										</div>
									</div>
								</form>
							</div>
						</div> 
					</div>	
					
			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="tableFixHead" id="tableFixHead">
							<div v-if="paginatedList.count == 0">
								{{ 'Nessun Log trovato' }}
							</div>
							<table v-else class="table table-bordered table-hover table-striped table-togglable"> 
			                    <thead class="sticky-top">
			                        <tr class="bg-secondary text-white">
										<th class="table-head-sm" style="width:2%;"> <input id="chkAllLogs" v-on:click="filters.selectAll('chkAllLogs',paginatedList.arr)" type="checkbox" class=""> </th>
										<th class="table-head-sm" style="width:10%;">Orario</th>
										<th class="table-head-sm" style="width:15%;">Livello</th>
										<th class="table-head-sm" style="width:30%;">Messaggio</th>
										<th class="table-head-sm" style="width:15%;">Ip</th>
										<th v-show="folderSelezionata != 'ERROR'" class="table-head-sm text-capitalize" v-for="col in colonneDinamiche" :key="col">
											{{ col }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(log,index) in paginatedList.arr" v-bind:key="'log-' + index">
										<td class="td-class text-center"> 
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="log.SELEZIONATO" class=""> 
										</td>
										<td class="td-class fs-sm">
											<span>{{log.ORARIO}}</span><br />
											<small class="badge bg-light badge-xs text-muted float-end cursor-pointer"></small>
										</td>
										<td class="td-class fs-sm"> 
											<span class="text-primary text-uppercase fw-bold cursor-pointer"> {{ log.LIVELLO }}</span><br />
											<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;" >--</span>
										</td>
										<td class="td-class fs-sm"> 
											<span class="badge text-secondary text-muted">{{ log?.TITOLO}}</span>
											<span class="float-end cursor-pointer" @click="folderSelezionata == 'ERROR' ? openStackTrace(log) : openStack(log)"><i class="fal fa-eye fa-fw"></i></span>
										</td>
										<td class="td-class fs-sm"> 
											<span class="badge text-secondary text-muted">{{ log.IP }}</span>
										</td>
										<td v-show="folderSelezionata != 'ERROR'" class="td-class fs-sm" v-for="col in colonneDinamiche" :key="'ctx-' + col">
											{{ log[col] || '-' }}
											<!--
											<div><i class="ph-check-circle fs-base lh-base align-top text-success me-1"></i> Utenti: <a href="#"></a></div>
											<div><i class="ph-clock fs-base lh-base align-top text-danger me-1"></i> Core: <a href="#">0</a></div>
											-->
										</td>	 
									</tr>
								</tbody>
							</table>     
                   		</div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">RISULTATI ></span>
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2">LIVELLI: {{ paginatedList.count }}</span> 
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end">
		                            <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH"></Pagine>
		                        </div>
	                        </div>
							<div class="col-4 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
                            </div>
						</div>
					</div>						
				</div>	
			</div>	

		</div>
	</div>	
  

	<!-- START MODALI -->
	<div class="modal" id="popUpStack">
		<div class="modal-dialog"  >
			<div class="modal-content" >
				<div class="modal-header modal-header-info">
					<h5 class="modal-title">STACK COMPLETO LOG</h5>
					<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
					</button>
				</div>
				<div class="modal-body">
					{{ logSelezionato?.TITOLO }}
					<p>{{ logSelezionato.MESSAGGIO }}</p>

				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-danger"><i class="fa fa-times fa-fw"></i>Chiudi</button>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" id="popUpStackTrace" tabindex="-1" role="dialog"  >
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-danger text-white">
					<h6 class="modal-title">Log dettaglio Errore</h6>
					<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">X</button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-2 form-group-1"><label class="font-weight-semibold">API:</label></div>
						<div class="col-md-10 form-group-1"><span class="form-control">{{ logSelezionato.TITOLO }}</span></div>
						<div class="col-md-2"><label class="font-weight-semibold">TITOLO:</label></div>
						<div class="col-md-10"><span class="form-control">{{getStringErrore(logSelezionato)}}</span></div>
					</div>                      
					<pre class="box_error" style="font-size:10px" v-if="logSelezionato.hasOwnProperty('stackTrace')">
						<strong>{{ logSelezionato.context.utente }}</strong><br/>
						{{logSelezionato.stackTrace}}<br/>
						{{logSelezionato.context.parametri}}
					</pre>
					<pre style="font-size:10px" v-else>{{logSelezionato.context}}</pre>
				</div>
				<div class="modal-footer">

				</div>
			</div>
		</div>
	</div>
        
</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'



export default {
    name:"Errori", 

    components:{
        Pagine,
		Datepicker,
    
    },

    data: function () {
        return {   
            apiStartup:'core/errori',
            filters:global.filters,
            GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
            arrayLogs: new Array(),
			arrayLogsFolders: new Array(),
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
                logLevel:{TYPE:'COMBO',VALUE:''},
                message:{TYPE:'TEXT',VALUE:''}
            },
            logSelezionato:{},
			today : new Date().toISOString().split('T')[0],
			folderSelezionata : '',
			idEnteCorrente : 0,

        }
    },

    methods: {
        getLogs: function (folder,data,idEnte) {
				this.folderSelezionata = folder;
				this.idEnteCorrente = idEnte;
				var path = "core/logs";
				if (folder == 'API' || folder == 'ERROR'){
					path = "core/errori";
				}
				utils.ajax(path, {'DOMINIO': folder,'DATA': data,'FK_ID_ENTE': idEnte}, (response) => {
					this.arrayLogs = response.data;
					// Reset per ogni get
					/*this.search = { 
						PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
						LIVELLO: { TYPE: 'COMBO', VALUE: '' },
						IP: { TYPE: 'TEXT', VALUE: '' }
					};*/
					const filtriStatici = ['FOLDER', 'ORARIO', 'LIVELLO', 'MESSAGGIO', 'IP'];
					const filtriDinamici = new Set();
					for (let i = 0; i < this.arrayLogs.length; i++) {
						const log = this.arrayLogs[i];
						for (let filtro in log) {
							if (!filtriStatici.includes(filtro)) {
								filtriDinamici.add(filtro);
							}
						}
					}
					for (let filtro of filtriDinamici) {
						this.search[filtro] = { TYPE: 'TEXT', VALUE: ''};
						
					}
					this.search.time = this.filters.formatDate(data);
				});
			},

        getLogsFolders: function () {
            utils.ajax('core/logs/folders',{}, (response) => {
                this.arrayLogsFolders = response.data;
            });
        },

        getStringErrore:function(_errore){
            var item = _errore.context;
            if (item == undefined)
                return "";
            if (item.hasOwnProperty("message")){
                return item.message;
            }
            else {
                if (item.hasOwnProperty("query")){
                    return item.errore ;
                }
                return "";
            }
        },

        openStackTrace:function(errore){
			this.filters.openPopUp("popUpStackTrace"); 		
            this.logSelezionato = utils.clone(errore);
            console.log(this.logSelezionato);
            if (this.logSelezionato.context.hasOwnProperty("message")){
                this.logSelezionato.stackTrace = this.logSelezionato.context.stackTrace;
            }
            else {
                if (this.logSelezionato.context.hasOwnProperty("query")){
                    this.logSelezionato.stackTrace = this.logSelezionato.context.query; //+ "\n\n---\n" + this.logSelezionato.context.parametri.join(",") ;
                }
            }
        },

		openStack(log){
			this.logSelezionato = utils.clone(log);
			this.filters.openPopUp('popUpStack');
		},

        refreshEnte : function(){
			this.idEnteCorrente = this.$root.idEnteCorrente;
			this.getLogs('EMAIL',this.search.time,this.idEnteCorrente);
        },

    }, 

    computed: {
        paginatedList(){
			var arr = utils.inGrid(this.arrayLogs,this.search);
            return arr;
        },
		filtriDinamici() {
			const result = [];
			const filtriStatici = ['PAGINATION', 'LIVELLO', 'IP'];
			for (let key in this.search) {
				if (!filtriStatici.includes(key)) {
					result.push({ key, value: this.search[key] });
				}
			}
			return result;
      	},

		colonneDinamiche() {
			const filtriStatici = ['FOLDER', 'ORARIO', 'LIVELLO', 'MESSAGGIO', 'IP', 'TITOLO'];
			const filtri = new Set();
			for (let i = 0; i < this.arrayLogs.length; i++) {
				const log = this.arrayLogs[i];
				for (let filtro in log) {
					if (!filtriStatici.includes(filtro)) {
					filtri.add(filtro);
					}
				}
			}
			return Array.from(filtri);
		},	 

    },		 

    created: function () {
		this.getLogsFolders();
		this.search.time = this.today;
		this.idEnteCorrente = this.$root.idEnteCorrente;
        this.getLogs('EMAIL', this.search.time,this.idEnteCorrente);

    },

}
</script>

